import { string, shape } from 'prop-types';

export const ChimeMeetingProps = {
  MeetingId: string.isRequired,
  MediaPlacement: shape({
    ScreenViewingUrl: shape.isRequired,
    AudioFallbackUrl: shape.isRequired,
    ScreenDataUrl: shape.isRequired,
    TurnControlUrl: shape.isRequired,
    ScreenSharingUrl: shape.isRequired,
    AudioHostUrl: shape.isRequired,
    SignalingUrl: shape.isRequired,
  }),
  MediaRegion: string.isRequired,
};

export const ChimeAttendeeProps = {
  ExternalUserId: string.isRequired,
  AttendeeId: string.isRequired,
  JoinToken: string.isRequired,
};

const meetingConstants = {
  statuses: {
    active: 'active',
    cancelled: 'cancelled',
    inactive: 'inactive',
  },
  qualityDefault: '720p',
  qualities: {
    '720p': {
      id: '720p',
      label: '720p',
      order: 0,
      params: {
        width: 1280,
        height: 720,
        frameRate: 30,
        maxBandwidthKbps: 4000,
      },
    },
    '540p': {
      id: '540p',
      label: '540p',
      order: 1,
      params: {
        width: 960,
        height: 540,
        frameRate: 15,
        maxBandwidthKbps: 1400,
      },
    },
    '360p': {
      id: '360p',
      label: '360p',
      order: 2,
      params: {
        width: 640,
        height: 360,
        frameRate: 15,
        maxBandwidthKbps: 600,
      },
    },
  },
  qualitiesOrder: [], // updated below
};

Object.values(meetingConstants.qualities)
  .sort((a, b) => a.order > b.order)
  .forEach((quality) => {
    meetingConstants.qualitiesOrder.push(quality.id);
  });

export default meetingConstants;
